/** Only a patient in the clinic (Waiting) or being seen (Attending) auto-creates an EMR and starts recording. */
export const VOICE_AUTO_START_STATUSES = new Set(["waiting", "attending"]);

/** Staff included in the controlled PWL voice-recording rollout. */
export const VOICE_AUTO_START_EMAILS = new Set([
  "danish.bhutyal@vetic.in",
  "satyendra.kumar@vetic.in",
  "karishma.narula@vetic.in",
  "anand.sindhu@vetic.in",
  "amit.tanwar@vetic.in",
  "aditya.kumar@vetic.in",
  "trisha.singhal@vetic.in",
  "neeraj.yadav@vetic.in",
  "amit.saini@vetic.in",
  "ajay.manhas@vetic.in",
  "sahil.nandal@vetic.in",
  "vikash.kumar@vetic.in",
  "gaurav.1@vetic.in",
  "manish.chaudhary@vetic.in",
  "arun.kumar@vetic.in",
  "lakshay.1@vetic.in",
  "nikhil.vashisth@vetic.in",
  "batsala@vetic.in",
  "param.nayal@vetic.in",
  "anshul.shukla@vetic.in",
  "ahad.parwez@vetic.in",
  "anurag.yadav@vetic.in",
  "devansh.banga@vetic.in",
  "racharla.srujan@vetic.in",
  "alka.kumari@vetic.in",
  "rahul.negi@vetic.in",
  "dhananjay.thakur@vetic.in",
  "aryan.oli@vetic.in",
  "jaideep1@vetic.in",
  "shivam.sharma1@vetic.in",
  "ashish.tripathi@vetic.in",
  "ashmeet.singh@vetic.in",
  "pragya.gurjar@vetic.in",
  "mohar.singh@vetic.in",
  "mukesh.kumar1@vetic.in",
  "prabhnoor.singh@vetic.in",
  "ritesh.panchal@vetic.in",
  "jasmin.grewal@vetic.in",
  "sandeep.01@vetic.in",
  "shiv.kumar@vetic.in",
  "shivam.vashisth@vetic.in",
  "akash.01@vetic.in",
  "rajesh.kumar@vetic.in",
  "ayush.sachan@vetic.in",
  "sirajul.mondal@vetic.in",
  "sunaina.khurana@vetic.in",
  "abhinav.saxena@vetic.in",
  "urmila.s@vetic.in",
  "famida.sherin@vetic.in",
  "muhammad.shafi@vetic.in",
  "fazil@vetic.in",
  "pathanjali.uttarkar@vetic.in",
  "mummadi.charan@vetic.in",
  "naveen.iruvuri@vetic.in",
  "rohini.bg@vetic.in",
  "jenifer.cherian@vetic.in",
  "suraj.gourav@vetic.in",
  "raghavendra.a@vetic.in",
  "apoorva.bk@vetic.in",
  "sreehari.s@vetic.in",
  "chaithra.sn@vetic.in",
  "bevara.sahithya@vetic.in",
  "saragada.devi@vetic.in",
  "manjula.madaka@vetic.in",
  "chaitra.jayagond@vetic.in",
  "busiraju.vyshnavi@vetic.in",
  "shreedev.rajendran@vetic.in",
  "harsha.mn@vetic.in",
  "nayana.mp@vetic.in",
  "shivaprasad.patil@vetic.in",
  "nithin.gowda@vetic.in",
  "sradha.nair@vetic.in",
  "sanjay.td@vetic.in",
  "kashi.vishwanath@vetic.in",
  "shaik.diljan@vetic.in",
  "harshita.tiwari@vetic.in",
  "surender.reddy@vetic.in",
  "konepalli.rekha@vetic.in",
  "konjeti.sowmya@vetic.in",
  "mannem.prathyusha@vetic.in",
  "achyutha.gupta@vetic.in",
  "syamala.devakinath@vetic.in",
  "korada.rohith@vetic.in",
  "kakevishnuthejareddy@vetic.in",
  "chilakala.ajay@vetic.in",
  "gangireddy.garichandrareddy@vetic.in",
  "m.saishashankreddy@vetic.in",
  "hema.giduturi@vetic.in",
  "niranjan.reddy@vetic.in",
  "tanuj.chandra@vetic.in",
  "hareesh.kumar@vetic.in",
  "enubarla.sonysharlet@vetic.in",
  "shashikiran.kavi@vetic.in",
  "anthati.gopinath@vetic.in",
  "aamer.shaik@vetic.in",
  "sadasiva.rao@vetic.in",
  "venkata.manoj@vetic.in",
  "k.srikanth@vetic.in",
  "tadikonda.chandrika@vetic.in",
  "akkala.goud@vetic.in",
  "pottasiri.sathish@vetic.in",
  "jaya.thangaraj@vetic.in",
  "nethaji.sekaran@vetic.in",
  "prachi.sharma@vetic.in",
  "shivaprasad.jangam@vetic.in",
  "vikash.raj@vetic.in"
]);

export const isVoiceAutoStartUser = (email: string | null | undefined): boolean =>
  VOICE_AUTO_START_EMAILS.has(email?.trim().toLowerCase() ?? "");

export const IPD_SERVICE_TYPE_ID = "6881fa1c-9146-45aa-8ad1-5d5c3c8d5301";

export const isIPDBooking = (serviceTypeId: string | null | undefined): boolean =>
  serviceTypeId?.trim().toLowerCase() === IPD_SERVICE_TYPE_ID;

export const isVoiceRolloutDoctor = ({
  email,
  roleName,
}: {
  email: string | null | undefined;
  roleName: string | null | undefined;
}): boolean => isVoiceAutoStartUser(email) && roleName?.trim().toLowerCase() === "doctor";

export const isVoiceAutoStartBookingStatus = (bookingStatus: string | null | undefined): boolean =>
  VOICE_AUTO_START_STATUSES.has(bookingStatus?.trim().toLowerCase() ?? "");

/**
 * How far either side of the scheduled start a Waiting booking still counts as
 * "the doctor is seeing this patient now" for auto EMR creation.
 */
export const VOICE_START_GRACE_MINUTES = 10;

const VOICE_START_GRACE_MS = VOICE_START_GRACE_MINUTES * 60 * 1000;

/** A cancelled appointment is never a live consultation. */
export const CANCELLED_BOOKING_STATUS = "cancelled";

/** The fields of a booking the voice gate reads; real API rows carry more. */
export interface IVoiceBookingLike {
  pet_id?: string;
  booking_status?: string;
  service_type_id?: string;
  booking_start_date_time?: string | null;
  booking_start_date?: string | null;
  booking_start_time?: string | null;
}

export const getBookingStartMs = (booking: IVoiceBookingLike | null | undefined): number | null => {
  const combined = booking?.booking_start_date_time?.trim();
  const split =
    booking?.booking_start_date?.trim() && booking?.booking_start_time?.trim()
      ? `${booking.booking_start_date.trim()}T${booking.booking_start_time.trim()}`
      : "";
  const raw = combined || split;
  if (!raw) return null;
  // Some endpoints send "YYYY-MM-DD HH:MM:SS" rather than the ISO "T" form.
  const parsed = new Date(raw.replace(" ", "T")).getTime();
  return Number.isFinite(parsed) ? parsed : null;
};

/**
 * True when now is within `VOICE_START_GRACE_MINUTES` either side of the
 * booking's scheduled start. Cancelled bookings and rows with no parseable
 * start time never qualify.
 */
export const isBookingWithinVoiceStartWindow = (
  booking: IVoiceBookingLike | null | undefined,
  nowMs: number = Date.now(),
): boolean => {
  const status = String(booking?.booking_status ?? "").trim().toLowerCase();
  if (status === CANCELLED_BOOKING_STATUS) return false;
  const startMs = getBookingStartMs(booking);
  if (startMs === null) return false;
  return Math.abs(nowMs - startMs) <= VOICE_START_GRACE_MS;
};

/**
 * The auto EMR creation gate for a single booking: Attending qualifies at any
 * time; Waiting qualifies only within `VOICE_START_GRACE_MINUTES` of its
 * scheduled start. Every other status (Upcoming included) never qualifies.
 */
export const isVoiceAutoCreateBooking = (
  booking: IVoiceBookingLike | null | undefined,
  nowMs: number = Date.now(),
): boolean => {
  const status = String(booking?.booking_status ?? "").trim().toLowerCase();
  if (status === "attending") return true;
  return status === "waiting" && isBookingWithinVoiceStartWindow(booking, nowMs);
};

export const shouldAutoStartVoiceFromPWL = ({
  email,
  roleName,
  booking,
}: {
  email: string | null | undefined;
  roleName: string | null | undefined;
  booking: IVoiceBookingLike | null | undefined;
  // Accepted for call-site compatibility but no longer gated on: IPD bookings are
  // now included for the VOICE_AUTO_START_EMAILS rollout.
  serviceTypeId?: string | null;
}): boolean => isVoiceRolloutDoctor({ email, roleName }) && isVoiceAutoCreateBooking(booking);

/** `?voice=1` - the PWL row already qualified (Attending, or Waiting within the window), so start straight away. */
export const VOICE_PARAM_START = "1";

/**
 * `?voice=check` - the PWL row did NOT qualify when it was drawn. PWL rows come
 * from a cached/polled list, so the status (and the clock) can have moved on
 * since. Rather than decide from the stale row, an allowlisted doctor is sent to
 * the EMR tab with this flag: the tab re-reads the booking from the appointments
 * API and runs the ordinary create-draft + start-recording flow only when it now
 * reads Attending, or Waiting within the window (see `petHasVoiceAutoCreateBooking`).
 * Anything else is a silent no-op.
 */
export const VOICE_PARAM_VERIFY = "check";

/**
 * True when the row does not qualify for auto-start but the doctor is on the
 * rollout - i.e. the booking is worth re-checking against the appointments API
 * before the voice flow is written off. Mirrors `shouldAutoStartVoiceFromPWL`,
 * inverted on the booking only.
 */
export const shouldVerifyVoiceFromPWL = ({
  email,
  roleName,
  booking,
}: {
  email: string | null | undefined;
  roleName: string | null | undefined;
  booking: IVoiceBookingLike | null | undefined;
}): boolean => isVoiceRolloutDoctor({ email, roleName }) && !isVoiceAutoCreateBooking(booking);

/**
 * True when this pet has an IPD (in-patient) booking that is still standing —
 * cancelled admissions don't count. Status and time are not consulted: an
 * admission is hospitalisation, not a consultation the doctor dictates an EMR
 * for, so it is the one visit the Create-EMR recording gate turns down.
 */
export const petHasIPDBooking = (
  bookings: IVoiceBookingLike[] | null | undefined,
  petId: string | null | undefined,
): boolean =>
  (bookings ?? []).some(
    (booking) =>
      String(booking?.pet_id) === String(petId) &&
      String(booking?.booking_status ?? "").trim().toLowerCase() !== CANCELLED_BOOKING_STATUS &&
      isIPDBooking(booking?.service_type_id),
  );

/**
 * The Create-EMR recording gate.
 *
 * Creating an EMR from the EMR tab records for an allowlisted user *whatever the
 * appointment says* — booking status and slot time are deliberately not read
 * here, unlike the PWL `?voice=check` gate (`petHasAttendingVoiceBooking`): the
 * doctor pressing Create EMR is the signal. IPD admissions are the only
 * exclusion. `bookings` should be today's list, since that is what the IPD check
 * is asked about.
 */
export const canRecordOnEMRCreate = ({
  email,
  bookings,
  petId,
}: {
  email: string | null | undefined;
  bookings: IVoiceBookingLike[] | null | undefined;
  petId: string | null | undefined;
}): boolean => isVoiceAutoStartUser(email) && !petHasIPDBooking(bookings, petId);

/**
 * True when this pet currently has an "attending" booking that is an IPD
 * admission. Such a visit must never start voice recording, so callers use this
 * to suppress the voice flag even for an allowlisted doctor.
 */
export const petHasAttendingIPDBooking = (
  bookings:
    | Array<{ pet_id?: string; booking_status?: string; service_type_id?: string }>
    | null
    | undefined,
  petId: string | null | undefined,
): boolean =>
  (bookings ?? []).some(
    (booking) =>
      String(booking?.pet_id) === String(petId) &&
      String(booking?.booking_status ?? "").trim().toLowerCase() === "attending" &&
      isIPDBooking(booking?.service_type_id),
  );

/**
 * True when this pet has a booking that counts as a live visit the doctor is
 * seeing, which qualifies for voice-to-EMR: the booking reads Waiting or
 * Attending. Upcoming, No Show, Completed and Cancelled never qualify, whatever
 * the scheduled time.
 *
 * EMR-tab actions (Create EMR / Edit draft / Voice-to-EMR) use this so an
 * allowlisted doctor starts recording for a patient being seen and not for an
 * unrelated visit. IPD bookings are INCLUDED for the VOICE_AUTO_START_EMAILS
 * rollout. Auto EMR creation from the PWL uses the stricter
 * `petHasVoiceAutoCreateBooking`, which holds Waiting to the start-time window.
 */
export const petHasAttendingVoiceBooking = (
  bookings:
    | Array<{ pet_id?: string; booking_status?: string; service_type_id?: string }>
    | null
    | undefined,
  petId: string | null | undefined,
): boolean =>
  (bookings ?? []).some(
    (booking) =>
      String(booking?.pet_id) === String(petId) &&
      isVoiceAutoStartBookingStatus(booking?.booking_status),
  );

/**
 * True when this pet has a booking that qualifies for auto EMR creation
 * (`isVoiceAutoCreateBooking`). The `?voice=check` re-read from the PWL runs
 * through here.
 */
export const petHasVoiceAutoCreateBooking = (
  bookings: IVoiceBookingLike[] | null | undefined,
  petId: string | null | undefined,
  nowMs: number = Date.now(),
): boolean =>
  (bookings ?? []).some(
    (booking) => String(booking?.pet_id) === String(petId) && isVoiceAutoCreateBooking(booking, nowMs),
  );

export const getVoiceAutoStartWindowName = (handoffKey: string): string =>
  `pwl_voice_emr_${handoffKey.replace(/[^a-zA-Z0-9_-]/g, "_")}`;

/**
 * Keys (`customerId:petId`) whose floating voice session is currently being
 * started. Shared across the module so any component in the SAME tab can tell a
 * start is already claimed and avoid a duplicate. A brand-new browser tab loads
 * a fresh module, so the set is empty there — which is exactly why a
 * right-click → "open in new tab" starts recording in the new tab instead.
 */
export const PWL_VOICE_INFLIGHT = new Set<string>();

export const voiceHandoffKey = (customerId: string, petId: string): string =>
  `${customerId}:${petId}`;

export const ACTIVE_EMR_STATUSES = new Set(["DRAFT", "CREATED"]);

/** The list endpoint is already scoped by customer+pet; older records keep the
 * pet id only inside customer_profile_section. */
const isEMRForPet = (
  emr: { pet_id?: string | null; customer_profile_section?: { pet_id?: string | null } | null } | null | undefined,
  petId: string,
): boolean => {
  const emrPetId = emr?.pet_id ?? emr?.customer_profile_section?.pet_id;
  return !emrPetId || String(emrPetId) === String(petId);
};

export const isActiveEMRForPet = (
  emr:
    | {
        emr_status?: string | null;
        emr_type?: string | null;
        pet_id?: string | null;
        customer_profile_section?: { pet_id?: string | null } | null;
      }
    | null
    | undefined,
  petId: string,
): boolean => {
  // Lab interpretation drafts are separate from the consultation EMR
  if (emr?.emr_type === "Lab Report") return false;
  const status = String(emr?.emr_status ?? "")
    .trim()
    .toUpperCase();
  if (!ACTIVE_EMR_STATUSES.has(status)) return false;

  return isEMRForPet(emr, petId);
};

/**
 * A visit the doctor has just finished. An EMR completed inside this window
 * belongs to the consultation the doctor is still standing in, so coming back
 * into the pet from the PWL must not silently open a second EMR for it.
 */
export const RECENT_COMPLETED_EMR_WINDOW_HOURS = 5;

const RECENT_COMPLETED_EMR_WINDOW_MS = RECENT_COMPLETED_EMR_WINDOW_HOURS * 60 * 60 * 1000;

export const COMPLETED_EMR_STATUSES = new Set(["COMPLETED", "COMPLETE"]);

/** EMR timestamps come back as epoch seconds; millisecond values are tolerated. */
const toEpochMs = (value: unknown): number | null => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric <= 0) return null;
  return numeric > 1e12 ? numeric : numeric * 1000;
};

/**
 * When the EMR was first submitted. Falls back to the last update (and then
 * creation) so a completed EMR from before `emr_completion_info` existed still
 * carries a usable time.
 */
export const getEMRCompletedAtMs = (
  emr:
    | {
        emr_completion_info?: { first_completed_at?: number | null } | null;
        updated_at?: number | null;
        created_at?: number | null;
      }
    | null
    | undefined,
): number | null =>
  toEpochMs(emr?.emr_completion_info?.first_completed_at) ??
  toEpochMs(emr?.updated_at) ??
  toEpochMs(emr?.created_at);

/**
 * The pet's most recently completed EMR, if it was completed within the last
 * `RECENT_COMPLETED_EMR_WINDOW_HOURS` hours. The PWL → EMR-tab auto-start uses
 * this to skip both the voice recording and the new draft: the consultation is
 * already written up, and a second EMR for the same visit is never wanted.
 * Returns `null` when there is no such EMR (auto-start proceeds as before).
 */
export const findRecentlyCompletedEMRForPet = <
  T extends {
    emr_status?: string | null;
    pet_id?: string | null;
    customer_profile_section?: { pet_id?: string | null } | null;
    emr_completion_info?: { first_completed_at?: number | null } | null;
    updated_at?: number | null;
    created_at?: number | null;
  },
>(
  emrList: T[] | null | undefined,
  petId: string,
  nowMs: number = Date.now(),
): T | null => {
  if (!Array.isArray(emrList)) return null;

  return (
    emrList
      .filter((emr) => {
        const status = String(emr?.emr_status ?? "").trim().toUpperCase();
        if (!COMPLETED_EMR_STATUSES.has(status)) return false;
        if (!isEMRForPet(emr, petId)) return false;

        const completedAt = getEMRCompletedAtMs(emr);
        // No usable timestamp — can't prove it is recent, so it must not block.
        if (completedAt === null) return false;

        const age = nowMs - completedAt;
        // A completion stamped in the future (clock skew) still counts as recent.
        return age < RECENT_COMPLETED_EMR_WINDOW_MS;
      })
      .sort((left, right) => (getEMRCompletedAtMs(right) ?? 0) - (getEMRCompletedAtMs(left) ?? 0))[0] ?? null
  );
};
